// Use full window.collection name for key
const urlStart = "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/";
const backgrounds = {
  "mug-prints" : {
    front: {
      White: urlStart + "mug_white.jpg",
      Black: urlStart + "mug_black.jpg",
      Green: urlStart + "mug_green.jpg",
      Yellow: urlStart + "mug_yellow.jpg",
      Orange: urlStart + "mug_orange.jpg",
      Red: urlStart + "mug_red.jpg",
      Pink: urlStart + "mug_pink.jpg",
      Blue: urlStart + "mug_blue.jpg",
    },
    back: {
      White: urlStart + "mug_white_back.jpg",
      Black: urlStart + "mug_black_back.jpg",
      Green: urlStart + "mug_green_back.jpg",
      Yellow: urlStart + "mug_yellow_back.jpg",
      Orange: urlStart + "mug_orange_back.jpg",
      Red: urlStart + "mug_red_back.jpg",
      Pink: urlStart + "mug_pink_back.jpg",
      Blue: urlStart + "mug_blue_back.jpg",
    }
  },
  "crewneck-sweatshirt": {
    front: {
      White: urlStart + "crewneck_front_white.jpg",
      Black: urlStart + "crewneck_front_black.jpg",
      Ash: urlStart + "crewneck_front_ash.jpg",
      Irish: urlStart + "crewneck_front_irish.jpg",
      Red: urlStart + "crewneck_front_red.jpg",
      Dark: urlStart + "crewneck_front_dark.jpg",
      Light: urlStart + "crewneck_front_light.jpg",
      Royal: urlStart + "crewneck_front_royal.jpg",
      Navy: urlStart + "crewneck_front_navy.jpg",
    },
    back: {
      White: urlStart + "crewneck_back_white.jpg",
      Black: urlStart + "crewneck_back_black.jpg",
      Ash: urlStart + "crewneck_back_ash.jpg",
      Irish: urlStart + "crewneck_back_irish.jpg",
      Red: urlStart + "crewneck_back_red.jpg",
      Dark: urlStart + "crewneck_back_dark.jpg",
      Light: urlStart + "crewneck_back_light.jpg",
      Royal: urlStart + "crewneck_back_royal.jpg",
      Navy: urlStart + "crewneck_back_navy.jpg",
    }
  },
  "crewneck-youth-sweatshirt": {
    front: {
      White: urlStart + "crewneck_front_white.jpg",
      Black: urlStart + "crewneck_front_black.jpg",
      Ash: urlStart + "crewneck_front_ash.jpg",
      Red: urlStart + "crewneck_front_red.jpg",
      Dark: urlStart + "crewneck_front_dark.jpg",
      Navy: urlStart + "crewneck_front_navy.jpg",
      Royal: urlStart + "crewneck_front_royal.jpg",
    },
    back: {
      White: urlStart + "crewneck_back_white.jpg",
      Black: urlStart + "crewneck_back_black.jpg",
      Ash: urlStart + "crewneck_back_ash.jpg",
      Red: urlStart + "crewneck_back_red.jpg",
      Dark: urlStart + "crewneck_back_dark.jpg",
      Navy: urlStart + "crewneck_back_navy.jpg",
      Royal: urlStart + "crewneck_back_royal.jpg",
    }
  },
  "hoodie-sweatshirt": {
    front: {
      White: urlStart + "hoodie_front_white.jpg",
      Black: urlStart + "hoodie_front_black.jpg",
      Ash: urlStart + "hoodie_front_ash.jpg",
      Irish: urlStart + "hoodie_front_irish.jpg",
      Red: urlStart + "hoodie_front_red.jpg",
      Dark: urlStart + "hoodie_front_dark.jpg",
      Light: urlStart + "hoodie_front_light.jpg",
      Royal: urlStart + "hoodie_front_royal.jpg",
      Navy: urlStart + "hoodie_front_navy.jpg",
    },
    back: {
      White: urlStart + "hoodie_back_white.jpg",
      Black: urlStart + "hoodie_back_black.jpg",
      Ash: urlStart + "hoodie_back_ash.jpg",
      Irish: urlStart + "hoodie_back_irish.jpg",
      Red: urlStart + "hoodie_back_red.jpg",
      Dark: urlStart + "hoodie_back_dark.jpg",
      Light: urlStart + "hoodie_back_light.jpg",
      Royal: urlStart + "hoodie_back_royal.jpg",
      Navy: urlStart + "hoodie_back_navy.jpg",
    }
  },
  "hoodie-youth-sweatshirt": {
    front: {
      White: urlStart + "hoodie_front_white.jpg",
      Black: urlStart + "hoodie_front_black.jpg",
      Ash: urlStart + "hoodie_front_ash.jpg",
      Irish: urlStart + "hoodie_front_irish.jpg",
      Red: urlStart + "hoodie_front_red.jpg",
      Dark: urlStart + "hoodie_front_dark.jpg",
      Light: urlStart + "hoodie_front_light.jpg",
      Royal: urlStart + "hoodie_front_royal.jpg",
      Navy: urlStart + "hoodie_front_navy.jpg",
    },
    back: {
      White: urlStart + "hoodie_back_white.jpg",
      Black: urlStart + "hoodie_back_black.jpg",
      Ash: urlStart + "hoodie_back_ash.jpg",
      Irish: urlStart + "hoodie_back_irish.jpg",
      Red: urlStart + "hoodie_back_red.jpg",
      Dark: urlStart + "hoodie_back_dark.jpg",
      Navy: urlStart + "hoodie_back_navy.jpg",
      Royal: urlStart + "hoodie_back_royal.jpg",
      Light: urlStart + "hoodie_back_light.jpg",
    }
  },
  "polo-shirt": {
    front: {
      White: urlStart + "polo_front_white.jpg",
      Black: urlStart + "polo_front_black.jpg",
      Ash: urlStart + "polo_front_ash.jpg",
      Red: urlStart + "polo_front_red.jpg",
      Navy: urlStart + "polo_front_navy.jpg",
      Light: urlStart + "polo_front_light.jpg",
      Royal: urlStart + "polo_front_royal.jpg",
      Kelly: urlStart + "polo_front_kelly.jpg",
    }
  },
  "polo-womens-shirt": {
    front: {
      White: urlStart + "polo_front_white.jpg",
      Black: urlStart + "polo_front_black.jpg",
      Ash: urlStart + "polo_front_ash.jpg",
      Red: urlStart + "polo_front_red.jpg",
      Navy: urlStart + "polo_front_navy.jpg",
      Light: urlStart + "polo_front_light.jpg",
      Royal: urlStart + "polo_front_royal.jpg",
      Kelly: urlStart + "polo_front_kelly.jpg",
    }
  },
  "polo-youth-shirt": {
    front: {
      White: urlStart + "polo_front_white.jpg",
      Black: urlStart + "polo_front_black.jpg",
      Ash: urlStart + "polo_front_ash.jpg",
      Red: urlStart + "polo_front_red.jpg",
      Navy: urlStart + "polo_front_navy.jpg",
      Light: urlStart + "polo_front_light.jpg",
      Royal: urlStart + "polo_front_royal.jpg",
      Kelly: urlStart + "polo_front_kelly.jpg",
    }
  },
  "single-canvas-featured-products" : {
    front: {
      small: urlStart + "office.jpg",
      medium: urlStart + "bedroom.jpg",
      large: urlStart + "livingroom.jpg",
    }
  },
  "poster-prints": {
    front: {
      small: urlStart + "office.jpg",
      medium: urlStart + "bedroom.jpg",
      large: urlStart + "livingroom.jpg",
    }
  },
  "metal-prints": {
    front: {
      small: urlStart + "office.jpg",
      medium: urlStart + "bedroom.jpg",
      large: urlStart + "livingroom.jpg",
    }
  },
  "tote-prints-large": {
    front: {
      static: urlStart + "tote_updated.jpg"
    }
  },
  "tote-prints-small": {
    front: {
      static: urlStart + "tote_updated.jpg"
    }
  },
  "tote-prints": {
    front: {
      static: urlStart + "tote-reg.jpg"
    }
  },
  "camping-mug-prints": {
    front: {
      static: urlStart + "campingmug.jpg"
    }
  }
}
const background = backgrounds[window.collectionName] || {};
for (const image in background.front) {
  const imageElement = new Image();
  imageElement.src = background.front[image];
  if (background.back) {
    const imageElement2 = new Image();
    imageElement2.src = background.back[image];
  }
}
export default background;
